import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { ELECTIVE_COURSES, StudentServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import permissions from "app/permissions";
import ListElectiveCourses from "./List";
import CreateElectiveCourse from "./Create";
import EditElectiveCourse from "./Edit";
import ShowElectiveCourse from "./Show";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <AutoStoriesIcon />,
  name: StudentServicePath + ELECTIVE_COURSES,
  title: "Свободноизбираеми курсове в МФ",
  list: <ListElectiveCourses />,
  create: <CreateElectiveCourse />,
  createPermission: permissions.canManageElectiveCourses,
  edit: <EditElectiveCourse />,
  editPermission: permissions.canManageElectiveCourses,
  show: <ShowElectiveCourse />,
  permission: permissions.canPreviewElectiveCourses,
};
